define([
    "jquery",
    "underscore",
    "marionette",
    "models/demo_member_model",
    "behaviors/form_errors_behavior",
    "behaviors/recaptcha_v3_behavior",
    "backbone.syphon",
    "holdon"
], function ($, _, Marionette, DemoMember, FormErrorsBehavior, ReCaptchaV3Behavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        ui: {
            'country': '#country_abbr',
            'accountType': '#account_type',
            'submitBtn': '#submit',
            'form': '#demo_account_form',
            'captchaImage': '#captcha_image',
            'demoFormWrapper': '#demo_form_wrapper',

            'leverage': '#leverage',
            'currencyAbbr': "#currency_abbr",
        },

        events: {
            "change @ui.accountType": function (e) {
                this.requestReadyInfoAndUpdateCurrencyAndLeverage();
            },
            "change @ui.currencyAbbr": function (e) {
                this.requestReadyInfoAndUpdateLeverage();
            },
            'click @ui.submitBtn': 'submit'
        },

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            },
            recaptcha: {
                behaviorClass: ReCaptchaV3Behavior,
                action: 'demo_account'
            }
        },

        initialize: function () {
            this.bindUIElements();
            this.setAccountType();
            this.updateCurrencyList(true);
            this.updateLeverageList(true);
            this.leverage_list = [];
            this.currency_list = [];

            this.model = new DemoMember();
            // recaptcha v3 added
            this.triggerMethod('init:recaptcha');
        },

        requestReadyInfoAndUpdateCurrencyAndLeverage: function (isInit = false) {
            let that = this;
      
            HoldOn.open({
              theme: "sk-fading-circle",
            });
      
            const lang = window.lang;
            const currency_abbr = this.ui.currencyAbbr.val();
            const demo_member_type_name = this.ui.accountType.val();
      
            requestBody = {
              lang,
              demo_member_type_name,
              currency_abbr,
            };
      
            $.ajax("/rest_open_account/ready_list", {
              method: "GET",
              data: requestBody,
              success: function (data) {
                that.leverage_list = data["leverages"];
                that.currency_list = data["currencies"];
                that.updateCurrencyList(isInit);
                that.updateLeverageList(isInit);
      
                HoldOn.close();
              },
            });

            this.updateCurrencyList(false);
            this.updateLeverageList(false);
        },

        requestReadyInfoAndUpdateLeverage: function (isInit = false) {
            let that = this;
      
            HoldOn.open({
              theme: "sk-fading-circle",
            });
      
            const lang = window.lang;
            const currency_abbr = this.ui.currencyAbbr.val();
            const demo_member_type_name = this.ui.accountType.val();
      
            requestBody = {
              lang,
              demo_member_type_name,
              currency_abbr,
            };
      
            $.ajax("/rest_open_account/ready_list", {
              method: "GET",
              data: requestBody,
              success: function (data) {
                that.leverage_list = data["leverages"];
                that.updateLeverageList(isInit);
      
                HoldOn.close();
              },
            });

            this.updateLeverageList(false);
        },

        // set the default(selected) currency based on selected county
        // only JPY when Japan is selected, otherwise set to USD
        updateCurrencyList: function (isInit = false) {
            const that = this;
            this.$('#currency_abbr').empty();

            if (isInit) {
            available_currencies = window.init_currency;
            } else {
            available_currencies = this.currency_list;
            }

            _.each(available_currencies, function (currency) {
                that.$('#currency_abbr').append("<option value='" + currency.currencyAbbr + "'>" + currency.currencyAbbr + "</option>");
            })
        },

        setAccountType: function () {
            const that = this;
            this.$('#account_type').empty();

            _.each(demo_member_types, function (type) {
                that.$('#account_type').append("<option value='" + type.demoMemberTypeName + "'>" + type.demoMemberTypeName + "</option>");
            })

        },

        updateLeverageList: function (isInit = false) {
            const that = this;
            this.$('#leverage').empty();

            if (isInit) {
            available_leverages = window.init_leverage;
            } else {
            available_leverages = this.leverage_list;
            }
            
            _.each(available_leverages, function (leverage) {
                that.$('#leverage').append("<option value='" + leverage.leverage + "'>" + leverage.leverageName + "</option>");
            })
            this.ui.leverage.find('option').last().prop('selected', 'selected');
        },

        submit: function (e) {
            var that = this;
            if (e) e.preventDefault();
            var formData = Backbone.Syphon.serialize(this);
            this.model.set(formData);
            var errors = this.model.validate();

            if (_.size(errors) < 1) {
                HoldOn.open({
                    theme: "sk-fading-circle"
                });
                this.triggerMethod('validate:recaptcha', function (err, token) {
                    if (err) {
                        var recaptchaError = {captcha_code: 'Detected bot activity. Please Try again later'};
                        that.triggerMethod('show:errors', recaptchaError);
                        return;
                    }
                    that.triggerMethod('set:token', token, that.ui.form);
                    // after setting up the form. Need to re serialize with the captcha token
                    formData = Backbone.Syphon.serialize(that);
                    that.model.set(formData);

                    that.model.save(null, {
                        type: 'POST',
                        success: function (model, res) {
                            if (ciEnv == 'production') {
                                window.ga('set', 'page', '/open_account/demo_account/complete');
                                window.ga('send', 'pageview');
                                fbq('track', '<demoaccount>');
                            }

                            that.ui.form[0].reset();
                            that.ui.captchaImage.attr('src', '/common/show_captcha');
                            that.triggerMethod('show:success');

                            that.ui.demoFormWrapper.hide();
                        },
                        error: function (model, error) {
                            if (error.responseJSON.captcha_check) {
                                that.captchaCheck = error.responseJSON.captcha_check;
                            }
                            delete error.responseJSON.captcha_check;
                            that.triggerMethod('show:errors', error.responseJSON);
                        }
                    }).always(function () {
                        HoldOn.close();
                    });
                });
            } else {
                this.triggerMethod('show:errors', errors);
            }
        }
    });
});